import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormPage } from '../../tailwindComponents/FormPage';
import {
  SupplierFormValues,
  emptySupplierLegalEntity,
  emptySupplierCorporateHierarchy,
  emptySupplierCompliance,
  emptySupplierClassification,
} from './types';
import {
  SupplierFormFields,
  supplierFormSchema,
  emptyLocation,
} from './SupplierFormFields';

export function SupplierForm({
  onSubmit,
  isSubmitting,
  header,
  pages,
  defaultValues,
}: {
  onSubmit: (data: SupplierFormValues) => void;
  isSubmitting: boolean;
  header: string;
  pages: { name: string; href: string; current: boolean }[];
  defaultValues?: Partial<SupplierFormValues>;
}) {
  const [currentStep, setCurrentStep] = useState(1);

  const methods = useForm({
    shouldUnregister: false,
    resolver: yupResolver(supplierFormSchema),
    mode: 'onChange',
    defaultValues: {
      supplierId: '',
      name: '',
      type: '',
      contactName: '',
      contactEmail: '',
      contactNumber: '',
      hqId: '',
      hqName: '',
      locations: [{ ...emptyLocation }],
      legalEntity: { ...emptySupplierLegalEntity },
      contacts: [],
      corporateHierarchy: { ...emptySupplierCorporateHierarchy },
      compliance: { ...emptySupplierCompliance },
      suppliedSkus: [],
      ...emptySupplierClassification,
      ...defaultValues,
    } as SupplierFormValues,
  });

  const { formState, control, setValue, clearErrors } = methods;

  return (
    <FormPage<SupplierFormValues>
      header={header}
      pages={pages}
      methods={methods}
      currentStep={currentStep}
      setCurrentStep={setCurrentStep}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
    >
      <SupplierFormFields
        control={control}
        formState={formState}
        setValue={setValue}
        clearErrors={clearErrors}
      />
    </FormPage>
  );
}
